import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { ExpiredModalComponent } from "@shared/component/expired-modal/expired-modal.component";
import { AppState } from "app/app.reducer";
import * as fromAuthActions from "app/store/actions/auth.actions";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isModalOpen = false;

  constructor(private store: Store<AppState>,
              private modalService: NgbModal,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err.status === 817 && !this.isModalOpen) {
          this.isModalOpen = true;
          const modalRef = this.modalService.open(ExpiredModalComponent, {
            windowClass: 'custom-modal-expired',
            centered: true,
            backdrop: 'static',
            keyboard: false,
          });
          modalRef.result.finally(() => {
            this.isModalOpen = false;
          });
        }
        if (err.status === 401) {
          const action = new fromAuthActions.LogoutSuccessAction();
          this.store.dispatch(action);
        }
        return throwError(err);
      })
    );
  }
}
